import { HttpClient } from "@angular/common/http";
import { inject, Service } from "@angular/core";
import { Translation, TranslocoLoader } from "@jsverse/transloco";
import { Observable } from "rxjs";

import { environment } from "../../../environments/environment";

@Service()
export class TranslocoHttpLoader implements TranslocoLoader {
    private readonly http = inject(HttpClient);

    public getTranslation(language: string): Observable<Translation> {
        return this.http.get<Translation>(`/i18n/${language}.json`, { params: { version: environment.version } });
    }
}
